import React from "react";
import { Navigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  try {
    const decoded = jwt_decode(token);
    if (!decoded?.isAdmin) {
      return <Navigate to="/un-authorized" replace />;
    }
    return children;
  } catch {
    localStorage.removeItem("authToken");
    return <Navigate to="/login" replace />;
  }
};

export default AdminRoute;
